import {client} from '../helpers/api';

export async function getAnnouncements() {
  return new Promise((resolve, reject) => {
    client
      .get('/api/announcements')
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
